module.exports = __webpack_public_path__ + "assets/img/driver-btn-58e621c1.png";